import { Check, Sparkles, Crown } from "lucide-react";

const FREE_FEATURES = [
  "Browse the full recipe feed",
  "Step-by-step Cook Mode",
  "Save unlimited favourites",
];

const PREMIUM_FEATURES = [
  "Everything in Free",
  "AI Creative Agent — chat with your own AI chef",
  "Snap ingredients → instant recipes",
  "Weekly Meal Planner",
  "Auto shopping list + Pantry (Supplies)",
];

export default function PricingTiers({ isPremium, isLoggedIn, onPremiumCta, ctaLabel, trialEligible = true }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
      {/* Free */}
      <div data-testid="tier-free" className="rounded-3xl border border-black/10 bg-white p-7 flex flex-col">
        <p className="text-xs font-mono uppercase tracking-[0.18em] text-nerd-light/40">Free</p>
        <div className="mt-3 flex items-baseline gap-1.5">
          <span className="font-display text-4xl font-extrabold tracking-tight">€0</span>
          <span className="text-sm text-nerd-light/50">/ forever</span>
        </div>
        <p className="text-sm text-nerd-light/55 mt-2 mb-6">Browse and collect recipes you love.</p>
        <ul className="space-y-3 flex-1">
          {FREE_FEATURES.map((f) => (
            <li key={f} className="flex items-start gap-2.5 text-sm text-nerd-light/85">
              <Check className="w-4 h-4 mt-0.5 shrink-0 text-nerd-light/50" /> {f}
            </li>
          ))}
        </ul>
        <div className="mt-7 h-11 flex items-center justify-center rounded-full border border-black/10 text-sm font-semibold text-nerd-light/50">
          {isLoggedIn ? "Your current plan" : "Included with any account"}
        </div>
      </div>

      {/* Premium */}
      <div data-testid="tier-premium-wrap" className="rounded-3xl flex">
        <div data-testid="tier-premium" style={{ backgroundColor: "#ffffff" }} className="relative rounded-3xl text-neutral-900 p-7 flex flex-col flex-1 overflow-hidden">
          <div className="absolute top-5 right-5 inline-flex items-center gap-1.5 text-[11px] font-semibold bg-black/5 text-neutral-900 rounded-full px-2.5 py-1">
            <Crown className="w-3.5 h-3.5" /> {trialEligible ? "7-day free trial" : "Most popular"}
          </div>
          <p className="text-xs font-mono uppercase tracking-[0.18em] text-neutral-400">Premium</p>
          <div className="mt-3 flex items-baseline gap-1.5">
            <span className="font-display text-4xl font-extrabold tracking-tight">€8.99</span>
            <span className="text-sm text-neutral-500">/ month</span>
          </div>
          <p className="text-sm text-neutral-500 mt-2 mb-6">
            {trialEligible ? "Free for 7 days, then €8.99/mo. Cancel anytime." : "Unlock the AI chef, planning & supplies."}
          </p>
          <ul className="space-y-3 flex-1">
            {PREMIUM_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-neutral-700">
                <Sparkles className="w-4 h-4 mt-0.5 shrink-0 text-neutral-400" /> {f}
              </li>
            ))}
          </ul>
          {isPremium ? (
            <div data-testid="premium-active-badge" className="mt-7 h-11 flex items-center justify-center gap-2 rounded-full bg-black/5 text-neutral-900 text-sm font-semibold">
              <Check className="w-4 h-4" /> You're Premium
            </div>
          ) : (
            <button
              data-testid="tier-premium-cta"
              onClick={onPremiumCta}
              style={{ backgroundColor: "#0a0a0a", color: "#ffffff" }}
              className="mt-7 h-11 rounded-full text-sm font-bold hover:opacity-90 transition-opacity"
            >
              {ctaLabel || (trialEligible ? "Start 7-day free trial" : "Subscribe — €8.99/mo")}
            </button>
          )}
          <p className="text-[11px] text-neutral-400 text-center mt-3">
            {trialEligible ? "No charge for 7 days · cancel anytime · Stripe" : "Cancel anytime · secure checkout by Stripe"}
          </p>
        </div>
      </div>
    </div>
  );
}
